<template>
  <ProSpaceGeoLayout class="home" ref="home">
    <template #top>
      <ProSpaceTopPanel :header="getTitle()">
        <template #center>
          <ProSpaceHLayout :gap="15" style="width: auto">
            <ProSpaceTag
              v-if="checkOrderStatusTag()"
              :type="statusTagType"
              :text="$t(`order_${order?.status}`)"
              is-border-style
            />
            <ProSpaceTag
              v-if="getBlockedPeriod"
              type="error"
              :text="$t('adjustmentsAreBlocked')"
              is-border-style
            />
          </ProSpaceHLayout>
        </template>
        <template #right>
          <ProSpaceIconButton
            icon="update"
            iconWidth="16px"
            iconHeight="16px"
            containerSize="20px"
            class="home__btn-reload"
            @click="reloadDashboard"
          />
          <ProSpaceButton
            v-if="
              checkAccess('dashboard-headerButton-upload') &&
              currentPeriod.status === 'opened'
            "
            type="primary"
            icon="plus"
            :label="$t('upload')"
            @click="actionImport"
          />
          <ProSpaceButton
            v-if="showPublish"
            type="primary"
            icon="check"
            :label="$t('publishOrder')"
            class="home__green-button"
            @click="
              showAlertConfirmOrder({
                title: $t('addressProgramTitleFlashPublishOrder'),
                text: $t('addressProgramTextFlashPublishOrder'),
                action: 'actionPublish',
                showAdjustmentUnlock: true,
                adjustmentUnlock: true
              })
            "
          />
          <ProSpaceButton
            v-if="checkApprove()"
            type="primary"
            icon="check"
            :label="$t('approveOrder')"
            @click="
              showAlertConfirmOrder({
                title: $t('addressProgramTitleFlashApproveOrder'),
                text: $t('addressProgramTextFlashApproveOrder'),
                action: 'actionApprove',
                showAdjustmentUnlock: false
              })
            "
          />
          <ProSpaceButton
            v-if="checkConfirm()"
            type="primary"
            icon="check"
            :label="$t('confirmOrder')"
            @click="
              showAlertConfirmOrder({
                title: $t('addressProgramTitleFlashConfirmOrder'),
                text: $t('addressProgramTextFlashConfirmOrder'),
                action: 'actionConfirm',
                showAdjustmentUnlock: false
              })
            "
          />
          <ProSpaceButton
            v-if="checkConfirmBudget()"
            type="primary"
            icon="check"
            :label="$t('confirmFactBudget')"
            @click="
              showAlertConfirmOrder({
                title: $t('addressProgramTitleFlashConfirmFactBudgetOrder'),
                text: $t('addressProgramTextFlashConfirmFactBudgetOrder'),
                action: 'actionConfirmFactBudget',
              })
            "
          />

          <!--          <ProSpaceButton
            v-if="checkAccess('dashboard-headerButton-download')"
            type="secondary"
            icon="cloud-arrow-down"
            :label="$t('downloadOrder')"
          />-->
          <ProSpaceButton
            v-if="showClose"
            icon="double-check"
            type="secondary"
            :label="$t('closePeriod')"
            @click="showClosePeriodModal = true"
          />
          <ProSpaceButton
            v-if="checkOpenPeriod()"
            icon="plus"
            type="secondary"
            :label="$t('openPeriod')"
            @click="actionOpenPeriod"
          />
          <ProSpaceDots
            :options="dotsHeaderOptions"
            :isSquare="true"
            @action="(action) => handleHeaderDots(action)"
          />
        </template>
      </ProSpaceTopPanel>
    </template>
    <template #center>
      <ProSpaceGeoLayout
        class="home__dashboard padding-10"
        style="min-width: 700px"
      >
        <template #top>
          <ProSpaceHLayout>
            <HomePeriod
              @filter-apply="handlerFilterApply"
              :key="getUuid"
              :disabled="loading"
            />
          </ProSpaceHLayout>
        </template>
        <template #center>
          <ProSpaceHLayout
            :gap="10"
            :class="[
              'padding-top-10 home__wrapper',
              { 'home__wrapper--agency': statusAgency },
            ]"
          >
            <ProSpaceVLayout :gap="10" class="home__dashboard-column">
              <ProSpaceBlock
                margin="0"
                padding="0"
                class="home__dashboard-block home__dashboard-block--1-1"
                height="auto"
              >
                <HomeDashboard :title="$t('adjustments')" />
                <ProSpaceBlock
                  :class="[
                    'home__dashboard-scroll',
                    {
                      'home__dashboard-scroll--loading': !adjustments,
                      'home__dashboard-scroll--sidebarOpen': breakpoint <= 1366,
                    },
                  ]"
                >
                  <ProSpaceVLayout :gap="5" align-items="center" is-inline-h>
                    <template v-if="adjustments">
                      <HomeDashboardStatus
                        tag-type="light-blue"
                        :tag-text="$t('adjustmentonacceptance')"
                        :label="$t('adjustmentOnAcceptanceLabel')"
                        :count="adjustments.onAcceptance"
                        :yellow-bg="true"
                        :isBreakpoint="isBreakpoint"
                        :breakpoints="{
                          start: startBreakpoint,
                          current: breakpoint,
                        }"
                        @click="
                          moveWithParams(
                            { status: 'onacceptance' },
                            'adjustments'
                          )
                        "
                      />
                      <HomeDashboardStatus
                        tag-type="blue"
                        :tag-text="$t('adjustmentonapproval')"
                        :label="$t('adjustmentOnApprovalLabel')"
                        :count="adjustments.onApproval"
                        :isBreakpoint="isBreakpoint"
                        :breakpoints="{
                          start: startBreakpoint,
                          current: breakpoint,
                        }"
                        @click="
                          moveWithParams(
                            { status: 'onapproval' },
                            'adjustments'
                          )
                        "
                      />
                      <HomeDashboardStatus
                        tag-type="teal"
                        :tag-text="$t('adjustmentcompleted')"
                        :label="$t('adjustmentCompletedLabel')"
                        :count="adjustments.completed"
                        :isBreakpoint="isBreakpoint"
                        :breakpoints="{
                          start: startBreakpoint,
                          current: breakpoint,
                        }"
                        @click="
                          moveWithParams({ status: 'completed' }, 'adjustments')
                        "
                      />
                    </template>
                    <template v-else>
                      <Skeleton
                        v-for="i in 3"
                        height="60px"
                        width="calc(100% - 20px)"
                      />
                    </template>
                  </ProSpaceVLayout>
                </ProSpaceBlock>
              </ProSpaceBlock>
              <ProSpaceBlock
                margin="0"
                padding="0"
                class="home__dashboard-block home__dashboard-block--1-2"
                height="calc(50% - 5px)"
              >
                <HomeDashboard :title="$t('lastCommentOnAdjustments')" />
                <ProSpaceBlock
                  :class="[
                    'home__dashboard-scroll',
                    {
                      'home__dashboard-scroll--loading': !comments,
                      'home__dashboard-scroll--sidebarOpen': breakpoint <= 1366,
                    },
                  ]"
                >
                  <ProSpaceVLayout :gap="5" align-items="center" is-inline-h>
                    <template v-if="comments && comments.length > 0">
                      <HomeDashboardComment
                        v-for="comment in comments"
                        :key="comment.id"
                        :id="comment.adjustmentOutletCode"
                        :title="comment.adjustmentAgencyValue"
                        :status="comment.adjustmentStatus"
                        :date="
                          comment.adjustmentDate || comment.adjustmentCreatedAt
                        "
                        :comment="comment.comment"
                        :fio="comment.fio"
                        :agency="comment.adjustmentAgencyValue"
                        @click="moveToItem(comment.adjustmentId)"
                      />
                    </template>
                    <template v-else-if="comments && comments.length === 0">
                      <ProSpaceVLayout
                        :gap="40"
                        style="height: calc(100% - 40px); padding-top: 40px"
                        justify-content="center"
                        align-items="center"
                      >
                        <ProSpaceIcon
                          icon="empty-grid"
                          colored
                          icon-width="100%"
                          icon-height="150px"
                        />
                        <div class="text-size-16 text-color-main">
                          {{ $t("noComments") }}
                        </div>
                      </ProSpaceVLayout>
                    </template>
                    <template v-else>
                      <Skeleton
                        v-for="i in 5"
                        height="94px"
                        width="calc(100% - 20px)"
                      />
                    </template>
                  </ProSpaceVLayout>
                </ProSpaceBlock>
              </ProSpaceBlock>
            </ProSpaceVLayout>

            <ProSpaceVLayout :gap="10" class="home__dashboard-column">
              <ProSpaceBlock
                margin="0"
                padding="0"
                :class="[
                  'home__dashboard-block home__dashboard-block--2-1',
                  { 'home__dashboard-block--agency': statusAgency },
                ]"
              >
                <HomeDashboard :title="getStatusOrdersTitle()" />
                <ProSpaceBlock
                  :class="[
                    'home__dashboard-scroll',
                    {
                      'home__dashboard-scroll--loading': !statusOrders,
                      'home__dashboard-scroll--sidebarOpen': breakpoint <= 1366,
                    },
                  ]"
                >
                  <ProSpaceVLayout :gap="10" align-items="center" is-inline-h>
                    <template v-if="statusOrders">
                      <ProSpaceHLayout
                        :gap="10"
                        align-items="stretch"
                        :class="{
                          'home-breakpoint': isBreakpoint,
                          'home__dashboard-h-statuses': !isBreakpoint,
                        }"
                      >
                        <HomeDashboardStatus
                          tag-type="plan"
                          :class="[
                            'home-dashboard-status--orders',
                            statusOrders.orderCreated?.toString().length >= 4
                              ? 'home-dashboard-status--orders-big'
                              : '',
                          ]"
                          :tag-text="getBorderedTagText('ordercreated')"
                          :label="$t('dashboardOrderCreate')"
                          :count="statusOrders.orderCreated"
                          :bordered="true"
                          :isBreakpoint="isBreakpoint"
                          :breakpoints="{
                            start: startBreakpoint,
                            current: breakpoint,
                          }"
                          @click="moveWithParams({ orderStatus: 'created' })"
                        />
                        <HomeDashboardStatus
                          tag-type="purple"
                          :class="[
                            'home-dashboard-status--orders',
                            statusOrders.orderPublished?.toString().length >= 4
                              ? 'home-dashboard-status--orders-big'
                              : '',
                          ]"
                          :tag-text="getBorderedTagText('orderpublished')"
                          :label="$t('dashboardOrderPublished')"
                          :count="statusOrders.orderPublished"
                          :bordered="true"
                          :isBreakpoint="isBreakpoint"
                          :breakpoints="{
                            start: startBreakpoint,
                            current: breakpoint,
                          }"
                          @click="moveWithParams({ orderStatus: 'published' })"
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        :gap="10"
                        align-items="stretch"
                        :class="{
                          'home-breakpoint': isBreakpoint,
                          'home__dashboard-h-statuses': !isBreakpoint,
                        }"
                      >
                        <HomeDashboardStatus
                          tag-type="blue-main"
                          :class="[
                            'home-dashboard-status--orders',
                            statusOrders.orderApproved?.toString().length >= 4
                              ? 'home-dashboard-status--orders-big'
                              : '',
                          ]"
                          :tag-text="getBorderedTagText('orderapproved')"
                          :label="$t('dashboardOrderApproved')"
                          :count="statusOrders.orderApproved"
                          :bordered="true"
                          :isBreakpoint="isBreakpoint"
                          :breakpoints="{
                            start: startBreakpoint,
                            current: breakpoint,
                          }"
                          @click="moveWithParams({ orderStatus: 'approved' })"
                        />
                        <HomeDashboardStatus
                          tag-type="teal"
                          :class="[
                            'home-dashboard-status--orders',
                            statusOrders.orderConfirmed?.toString().length >= 4
                              ? 'home-dashboard-status--orders-big'
                              : '',
                          ]"
                          orderApproved
                          :tag-text="getBorderedTagText('ordercompleted')"
                          :label="$t('dashboardOrderCompleted')"
                          :count="statusOrders.orderConfirmed"
                          :bordered="true"
                          :isBreakpoint="isBreakpoint"
                          :breakpoints="{
                            start: startBreakpoint,
                            current: breakpoint,
                          }"
                          @click="moveWithParams({ orderStatus: 'completed' })"
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        :gap="10"
                        align-items="stretch"
                        :class="{
                          'home-breakpoint': isBreakpoint,
                          'home__dashboard-h-statuses': !isBreakpoint,
                        }"
                      >
                        <HomeDashboardStatus
                          tag-type="info"
                          :tag-text="$t('factBudgetLoad')"
                          :label="$t('factedBudgetLoaded')"
                          :count="statusOrders.orderFactBudgetLoaded"
                          :bordered="true"
                          :isBreakpoint="isBreakpoint"
                          :breakpoints="{
                            start: startBreakpoint,
                            current: breakpoint,
                          }"
                          @click="moveWithParams({ orderStatus: 'factBudgetLoaded' })"
                        />
                        <HomeDashboardStatus
                          tag-type="success"
                          :tag-text="$t('factBudgetApprove')"
                          :label="$t('factedBudgetApproved')"
                          :count="statusOrders.orderFactBudgetApproved"
                          :bordered="true"
                          :isBreakpoint="isBreakpoint"
                          :breakpoints="{
                            start: startBreakpoint,
                            current: breakpoint,
                          }"
                          @click="moveWithParams({ orderStatus: 'factBudgetApproved' })"
                        />
                      </ProSpaceHLayout>
                    </template>
                    <template v-else-if="statusAgency">
                      <HomeDashboardStatus
                        tag-type="select-blue"
                        :tag-text="$t('byKas')"
                        :label="$t('byKasLabel')"
                        :count="statusAgency?.kasAssignmentCount"
                        :red-bg="
                          statusAgency?.kasAssignmentCount <
                          currentKpi?.outletCount
                        "
                        :class="{ 'pointer-events-none': !isUserHasAgency }"
                        @click="moveWithParams({ notBy: 'kasValue' })"
                      />
                      <HomeDashboardStatus
                        tag-type="select-blue"
                        :tag-text="$t('byMerchs')"
                        :label="$t('byMerchsLabel')"
                        :count="statusAgency?.merchandiserAssignmentCount"
                        :red-bg="
                          statusAgency?.merchandiserAssignmentCount <
                          currentKpi?.outletCount
                        "
                        :class="{ 'pointer-events-none': !isUserHasAgency }"
                        @click="moveWithParams({ notBy: 'merchandiserValue' })"
                      />
                    </template>
                    <template v-else>
                      <ProSpaceHLayout
                        :gap="10"
                        :align-items="isBreakpoint ? 'center' : 'flex-start'"
                        justify-content="center"
                        :class="{ 'home-breakpoint': isBreakpoint }"
                      >
                        <Skeleton
                          height="80px"
                          :width="
                            isBreakpoint
                              ? `calc(100% - 20px)`
                              : `calc(50% - 15px)`
                          "
                        />
                        <Skeleton
                          height="80px"
                          :width="
                            isBreakpoint
                              ? `calc(100% - 20px)`
                              : `calc(50% - 15px)`
                          "
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        :gap="10"
                        :align-items="isBreakpoint ? 'center' : 'flex-start'"
                        justify-content="center"
                        :class="{ 'home-breakpoint': isBreakpoint }"
                      >
                        <Skeleton
                          height="80px"
                          :width="
                            isBreakpoint
                              ? `calc(100% - 20px)`
                              : `calc(50% - 15px)`
                          "
                        />
                        <Skeleton
                          height="80px"
                          :width="
                            isBreakpoint
                              ? `calc(100% - 20px)`
                              : `calc(50% - 15px)`
                          "
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        :gap="10"
                        :align-items="isBreakpoint ? 'center' : 'flex-start'"
                        justify-content="center"
                        :class="{ 'home-breakpoint': isBreakpoint }"
                      >
                        <Skeleton
                          height="80px"
                          :width="
                            isBreakpoint
                              ? `calc(100% - 20px)`
                              : `calc(50% - 15px)`
                          "
                        />
                        <Skeleton
                          height="80px"
                          :width="
                            isBreakpoint
                              ? `calc(100% - 20px)`
                              : `calc(50% - 15px)`
                          "
                        />
                      </ProSpaceHLayout>
                    </template>
                  </ProSpaceVLayout>
                </ProSpaceBlock>
              </ProSpaceBlock>
              <ProSpaceBlock
                margin="0"
                padding="0"
                :class="[
                  'home__dashboard-block home__dashboard-block--2-2',
                  { 'home__dashboard-block--agency': statusAgency },
                ]"
              >
                <HomeDashboard :title="$t('statusesByOutlets')" />
                <ProSpaceBlock
                  :class="[
                    'home__dashboard-scroll',
                    {
                      'home__dashboard-scroll--loading': !statusOutlets,
                      'home__dashboard-scroll--sidebarOpen': breakpoint <= 1366,
                    },
                  ]"
                >
                  <ProSpaceVLayout :gap="5" align-items="center" is-inline-h>
                    <template v-if="statusOutlets">
                      <HomeDashboardStatus
                        v-if="checkAccess('dashboard-draft-block')"
                        tag-type="draft"
                        :tag-text="$t('draft')"
                        :label="$t('dashboardStatusDraft')"
                        :count="statusOutlets.addressProgramDraft"
                        :isBreakpoint="isBreakpoint"
                        :breakpoints="{
                          start: startBreakpoint,
                          current: breakpoint,
                        }"
                        @click="moveWithParams({ status: 'draft' })"
                      />
                      <HomeDashboardStatus
                        tag-type="light-blue"
                        :tag-text="$t('plan')"
                        :label="$t('dashboardStatusPlan')"
                        :count="statusOutlets.addressProgramPlan"
                        :isBreakpoint="isBreakpoint"
                        :breakpoints="{
                          start: startBreakpoint,
                          current: breakpoint,
                        }"
                        @click="moveWithParams({ status: 'plan' })"
                      />
                      <HomeDashboardStatus
                        tag-type="teal"
                        :tag-text="`${$t('plan')}+${$t('fact')}`"
                        :label="$t('dashboardStatusPlanPlusFact')"
                        :count="statusOutlets.addressProgramPlanFact"
                        :isBreakpoint="isBreakpoint"
                        :breakpoints="{
                          start: startBreakpoint,
                          current: breakpoint,
                        }"
                        @click="moveWithParams({ status: 'planFact' })"
                      />
                    </template>
                    <template v-else>
                      <Skeleton height="60px" width="calc(100% - 20px)" />
                      <Skeleton height="60px" width="calc(100% - 20px)" />
                      <Skeleton height="60px" width="calc(100% - 20px)" />
                    </template>
                  </ProSpaceVLayout>
                </ProSpaceBlock>
              </ProSpaceBlock>
              <ProSpaceBlock
                margin="0"
                padding="0"
                class="home__dashboard-block home__dashboard-block--2-3"
              >
                <HomeDashboard :title="$t('grouping')" />
                <ProSpaceBlock
                  :class="[
                    'home__dashboard-scroll',
                    {
                      'home__dashboard-scroll--sidebarOpen': breakpoint <= 1366,
                    },
                  ]"
                >
                  <ProSpaceVLayout :gap="5" align-items="center" is-inline-h>
                    <HomeDashboardGrouping
                      :text="$t('byNetwork')"
                      @click="moveWithParams({ groups: ['NetworkId'] })"
                    />
                    <HomeDashboardGrouping
                      :text="$t('byTerritories')"
                      @click="moveWithParams({ groups: ['KADLId'] })"
                    />
                    <HomeDashboardGrouping
                      v-if="checkAccess('dashboard-agency-grouping')"
                      :text="$t('byAgencies')"
                      @click="moveWithParams({ groups: ['AgencyId'] })"
                    />
                    <HomeDashboardGrouping
                      v-else
                      :text="$t('byKAS')"
                      @click="moveWithParams({ groups: ['KASValue'] })"
                    />
                  </ProSpaceVLayout>
                </ProSpaceBlock>
              </ProSpaceBlock>
            </ProSpaceVLayout>

            <ProSpaceBlock
              margin="0"
              padding="0"
              class="home__dashboard-column home__dashboard-block home__dashboard-block--3-1"
              height="100%"
              width="calc(100% / 3)"
            >
              <HomeDashboard :title="$t('kpi')"> </HomeDashboard>
              <ProSpaceBlock
                :class="[
                  'home__dashboard-scroll',
                  {
                    'home__dashboard-scroll--loading': !currentKpi,
                    'home__dashboard-scroll--sidebarOpen': breakpoint <= 1366,
                  },
                ]"
              >
                <ProSpaceVLayout :gap="10" align-items="center" is-inline-h>
                  <template v-if="currentKpi">
                    <HomeDashboard :title="$t('coverageParameters')">
                      <template #body>
                        <ProSpaceHLayout
                          :gap="5"
                          align-items="stretch"
                          :class="{ 'home-breakpoint': isBreakpoint }"
                        >
                          <HomeDashboardItem
                            :label="$t('recommendForCT')"
                            :count="currentKpi.outletCount"
                          />
                          <HomeDashboardItem
                            :label="$t('totalTT')"
                            :count="outletTotal"
                            style="height: auto"
                          />
                        </ProSpaceHLayout>
                      </template>
                    </HomeDashboard>
                    <div class="dashboard-kpi-container">
                      <HomeDashboard :title="$t('openKpi')" />
                      <TableKpiCoverage :addressProgramOrder="currentKpi" />
                    </div>
                    <div class="dashboard-kpi-container">
                      <HomeDashboard
                        :title="`${$t('businessKpi')} ${$t('and')}  ${$t('budget')}`"
                      >
                        <template #header>
                          <MaapSelectButton
                            v-model="activeKpi"
                            :options="[
                              this.$t('businessKpi'),
                              this.$t('budget'),
                            ]"
                          />
                        </template>
                      </HomeDashboard>
                      <TableKpiBusiness
                        :addressProgramOrder="currentKpi"
                        v-if="activeKpi"
                      />
                      <TableKpiBudget
                        :addressProgramOrder="currentKpi"
                        v-else
                      />
                    </div>
                  </template>
                  <template v-else>
                    <Skeleton height="128px" width="calc(100% - 20px)" />
                    <Skeleton height="160px" width="calc(100% - 20px)" />
                    <Skeleton height="220px" width="calc(100% - 20px)" />
                    <Skeleton height="335px" width="calc(100% - 20px)" />
                  </template>
                </ProSpaceVLayout>
              </ProSpaceBlock>
            </ProSpaceBlock>
          </ProSpaceHLayout>
        </template>
      </ProSpaceGeoLayout>
    </template>
  </ProSpaceGeoLayout>
  <AddressProgramOrderModalImport
    v-model="showImportModal"
    accept=".xlsx"
    :checkAccess="checkAccess"
    @loading="loadingHandler"
    @close="showImportModal = false"
  />
  <ProSpaceFlashMessage
    v-model="showClosePeriodModal"
    icon="circle-check"
    :applyTxt="$t('confirmTxt')"
    :cancelTxt="$t('cancelTxt')"
    :title="$t('periodClosingTitle')"
    :needHideApply="true"
    @apply="actionClosePeriod"
    @cancel="showClosePeriodModal = false"
  >
    {{ `${$t("promptTxtClosePeriod")} ${currentPeriod?.name} ?` }}
  </ProSpaceFlashMessage>
  <ProSpaceFlashMessage
    v-model="confirmationOrdersModalState.show"
    class="confirmation-orders-modal"
    icon="flash-warning"
    :cancelTxt="$t('cancelTxt')"
    :title="confirmationOrdersModalState.title"
    :needHideApply="false"
    :applyTxt="$t('confirmTxt')"
    @apply="confirmationOrdersModalAction(confirmationOrdersModalState.action, confirmationOrdersModalState.adjustmentUnlock)"
    @cancel="confirmationOrdersModalState.show = false"
  >
    <ProSpaceVLayout :gap="10" align-items="center" is-inline-h>
      <span
        v-html="confirmationOrdersModalState.text"
      />
      <ProSpaceHLayout v-if="confirmationOrdersModalState.showAdjustmentUnlock" justifyContent="center">
        <Checkbox
          v-model="confirmationOrdersModalState.adjustmentUnlock"
          class="prospace-checkbox__input"
          name="adjustmentUnlock"
          inputId="adjustmentUnlock"
          binary
        />
        <label for="adjustmentUnlock"> {{ $t('adjustmentUnlockTxt') }} </label>
      </ProSpaceHLayout>
    </ProSpaceVLayout>
  </ProSpaceFlashMessage>
</template>
<script>
import {
  ProSpaceGeoLayout,
  ProSpaceTopPanel,
  ProSpaceButton,
  ProSpaceIconButton,
  ProSpaceHLayout,
  ProSpaceVLayout,
  ProSpaceTag,
  ProSpaceBlock,
  ProSpaceIcon,
  ProSpaceFlashMessage,
  ProSpaceSelectButton,
  ProSpaceDots,
} from "@prospace/prospace-components-library";
import Checkbox from "primevue/checkbox";
import Skeleton from "primevue/skeleton";
import HomePeriod from "./components/HomePeriod.vue";
import HomeDashboard from "./components/HomeDashboard.vue";
import HomeDashboardStatus from "./components/HomeDashboardStatus.vue";
import HomeDashboardGrouping from "./components/HomeDashboardGrouping.vue";
import HomeDashboardKpi from "./components/HomeDashboardKpi.vue";
import HomeDashboardItem from "./components/HomeDashboardItem.vue";
import HomeDashboardComment from "./components/HomeDashboardComment.vue";
import accessMixin from "../../../../../Frontends/Common/utils/elementAccess/accessMixin";
import AddressProgramOrderModalImport from "../../views/AddressProgramOrders/components/AddressProgramOrderModalImport";
import { OrderService } from "../../services/OrderService";
import { DashboardService } from "../../services/DashboardService.js";
import { MarsPeriodService } from "../../services/MarsPeriodService";
import MaapSelectButton from "@components/ui/MaapSwitchPanel";
import { mapGetters } from "vuex";
import TableKpiBusiness from "@components/entities/TableKpiBusiness";
import TableKpiBudget from "@components/entities/TableKpiBudget";
import TableKpiCoverage from "@components/entities/TableKpiCoverage";
export default {
  mixins: [accessMixin],
  components: {
    ProSpaceGeoLayout,
    ProSpaceTopPanel,
    ProSpaceButton,
    ProSpaceIconButton,
    ProSpaceHLayout,
    ProSpaceVLayout,
    ProSpaceTag,
    ProSpaceBlock,
    ProSpaceIcon,
    Skeleton,
    HomePeriod,
    HomeDashboard,
    HomeDashboardStatus,
    HomeDashboardGrouping,
    HomeDashboardKpi,
    HomeDashboardItem,
    HomeDashboardComment,
    AddressProgramOrderModalImport,
    ProSpaceFlashMessage,
    ProSpaceSelectButton,
    Checkbox,
    MaapSelectButton,
    ProSpaceDots,
    TableKpiBusiness,
    TableKpiBudget,
    TableKpiCoverage,
  },
  data() {
    return {
      loading: false,
      showImportModal: false,
      orderService: new OrderService(),
      marsPeriodService: new MarsPeriodService(),
      dashboardService: new DashboardService(),
      order: null,
      canPublish: false,
      canClose: false,
      currentKpi: null,
      statusOrders: null,
      statusAgency: null,
      statusOutlets: null,
      statusTagType: null,
      adjustments: null,
      comments: null,
      outletTotal: null,
      ro: null,
      breakpoint: null,
      uniqueKey: Math.random().toString(16).slice(2),
      showClosePeriodModal: false,
      confirmationOrdersModalState: {
        show: false,
      },
      startBreakpoint: null,
      isSetStartBreakpoint: false,
      activeKpi: true,
    };
  },
  mounted() {
    this.bindResizeObserver();
  },
  unmounted() {
    this.unbindResizeObserver();
  },
  methods: {
    async loadData() {
      this.loadOrder();
      this.getData();
    },
    async getData() {
      this.getKpi();
      if (this.checkAgencyBlock()) {
        this.getStatusAgency();
      } else {
        this.getStatusOrders();
      }
      this.getStatusOutlets();
      this.getAdjustment();
      this.getComments();
    },
    async getKpi() {
      this.currentKpi = null;
      const res = await this.dashboardService.getKpi();
      if (!res) {
        return;
      }
      this.currentKpi = res.data[0] || {};
      this.getOutletTotal();
    },
    async getOutletTotal() {
      this.outletTotal = null;
      const res = await this.dashboardService.getOutletTotal();
      if (!res) {
        return;
      }
      this.outletTotal = res.data || 0;
    },
    async getStatusOrders() {
      this.statusOrders = null;
      const res = await this.dashboardService.getStatusOrders();
      if (!res) {
        return;
      }
      this.statusOrders = res.data;
    },
    async getStatusAgency() {
      this.statusAgency = null;
      const res = await this.dashboardService.getStatusAgency();
      if (!res) {
        return;
      }
      this.statusAgency = res.data;
    },
    async getStatusOutlets() {
      this.statusOutlets = null;
      const res = await this.dashboardService.getStatusOutlets();
      if (!res) {
        return;
      }
      this.statusOutlets = res.data;
    },
    async getAdjustment() {
      this.adjustments = null;
      const res = await this.dashboardService.getAdjustment();
      if (!res) {
        return;
      }
      this.adjustments = res.data;
    },
    async getComments() {
      this.comments = null;
      const res = await this.dashboardService.getComments();
      if (!res) {
        return;
      }
      this.comments = res.data?.records ?? [];
    },
    handlerFilterApply(filter) {
      this.dashboardService.setFilter(filter);
      this.getData();
    },
    getBorderedTagText(status) {
      const text = this.$t(status).toLowerCase();
      const order = this.$t("order");
      return `${order} ${text}`;
    },
    bindResizeObserver() {
      const el = this.$refs.home.$el;
      this.ro = new ResizeObserver(this.handlerResize).observe(el);
    },
    unbindResizeObserver() {
      if (!this.ro) {
        return;
      }
      const el = this.$refs.home.$el;
      this.ro.unobserve(el);
    },
    handlerResize() {
      if (!this.$refs.home) {
        return;
      }
      const el = this.$refs.home.$el;
      this.breakpoint = el.offsetWidth;
      if (!this.isSetStartBreakpoint) {
        this.startBreakpoint = this.breakpoint;
        this.isSetStartBreakpoint = true;
      }
    },
    moveToItem(id, name = "adjustment") {
      this.$router.push(`${name}/${id}`);
    },
    moveWithParams(params, name = "addressprogramorders") {
      if (name === "addressprogramorders") {
        params = { ...params, coverage: true };
      }
      this.$router.push({ name, params });
    },
    actionImport() {
      this.showImportModal = true;
    },
    // order publishing
    // next operation - approve
    // CO Admin only
    actionPublish(adjustmentUnlock) {
      let me = this;
      this.confirmationOrdersModalState.show = false;
      me.loadingHandler(true);
      me.orderService.publish(me.currentPeriod.id, adjustmentUnlock).then(() => {
        let periodUpdateModel = _.cloneDeep(me.currentPeriod);
        periodUpdateModel.isBlocked = !adjustmentUnlock;
        if (!periodUpdateModel.code)
          periodUpdateModel.code = periodUpdateModel.id.toString();

        this.marsPeriodService.update(periodUpdateModel).then((res) => {
          me.$store.dispatch("marsPeriodStore/setMarsPeriod", res.data[0]);
          me.loadData();
        })
      });
    },
    // order approving
    // next operation - confirmation
    // Agency Admin only
    actionApprove() {
      let me = this;
      this.confirmationOrdersModalState.show = false;
      me.loadingHandler(true);
      me.orderService.approve(me.currentPeriod.id).then(() => {
        this.loadData();
      });
    },
    //order confirmation (final status)
    //next operation - close period
    // Agency Admin only
    actionConfirm() {
      let me = this;
      this.confirmationOrdersModalState.show = false;
      me.loadingHandler(true);
      me.orderService.confirm(me.currentPeriod.id).then(() => {
        this.loadData();
      });
    },
    actionConfirmFactBudget() {
      let me = this;
      this.confirmationOrdersModalState.show = false;
      me.loadingHandler(true);
      me.orderService.confirmFactBudget(me.currentPeriod.id).then(() => {
        this.loadData();
      });
    },
    loadingHandler(val) {
      this.loading = val;
    },
    //open period selection window
    actionOpenPeriod() {
      this.$store.commit("marsPeriodStore/SET_PERIODMODALSTATE", true);
    },
    actionClosePeriod() {
      this.showClosePeriodModal = false;
      let me = this;
      me.loadingHandler(true);
      me.marsPeriodService.close(me.currentPeriod.id).then((res) => {
        if (res?.data?.data) {
          this.$store.commit("marsPeriodStore/SET_MARSPERIOD", res.data.data);
        }
        // me.currentPeriod = res?.data?.data ?? me.currentPeriod;
        this.loadData();
      });
    },
    // get header title
    // if Agency user - agency name otherwise "Mars"
    getTitle() {
      let me = this;
      if (
        me.checkAccess("dashboard-headertag-orderStatus") &&
        me.userinfo.agencyLinkType == "AGENCY"
      ) {
        return me.userinfo.agencyLinkAgencyValue + me.$t("dashboardTitle");
      } else {
        return me.$t("mars") + me.$t("dashboardTitle");
      }
    },
    // if agency user
    // load current period published order for user agency only
    loadOrder() {
      let me = this;
      me.loadingHandler(true);
      if (me.userinfo.agencyLinkType == "AGENCY") {
        me.orderService.get(me.currentPeriod.id).then((res) => {
          let record = res?.data?.data;
          if (record) {
            me.order = record;
          } else {
            me.order = null;
          }
        });
        me.loadingHandler(false);
      } else {
        me.checkPublish();
      }
    },
    checkPublish() {
      let me = this;
      this.loadingHandler(true);
      if (this.checkAccess("request-checkPublish")) {
        this.orderService.checkPublish(this.currentPeriod.id).then((res) => {
          me.canPublish = res.data?.data?.canPublish;
          me.canClose = res.data?.data?.canClose;
          me.loadingHandler(false);
        });
      } else {
        this.canPublish = false;
        this.canClose = false;
        this.loadingHandler(false);
      }
    },
    checkApprove() {
      return (
        this.checkAccess("dashboard-headerButton-approve") &&
        this.order &&
        this.order.canApprove
      );
    },
    checkConfirm() {
      return (
        this.checkAccess("dashboard-headerButton-confirm") &&
        this.order &&
        this.order.canConfirm
      );
    },
    checkConfirmBudget() {
      return (
        this.checkAccess("dashboard-headerButton-confirm") &&
        this.order &&
        this.order.canConfirmFactBudget
      );
    },
    checkOrderStatusTag() {
      if (this.order) {
        switch (this.order.status) {
          case "published":
            this.statusTagType = "purple";
            break;
          case "approved":
            this.statusTagType = "blue-main";
            break;
          case "completed":
            this.statusTagType = "teal";
            break;
          case "created":
            this.statusTagType = "plan";
            break;
          case "factBudgetLoaded":
            this.statusTagType = "info";
            break;
          case "factBudgetApproved":
            this.statusTagType = "success";
            break;
          default:
            this.statusTagType = "default";
        }
      }
      return (
        this.checkAccess("dashboard-headertag-orderStatus") &&
        this.userinfo.agencyLinkType == "AGENCY" &&
        this.order
      );
    },
    checkOpenPeriod() {
      return this.checkAccess("dashboard-headerButton-openPeriod");
    },
    checkAgencyBlock() {
      return this.checkAccess("dashboard-agency-block");
    },
    reloadDashboard() {
      this.uniqueKey += 1;
      this.loadData();
    },
    getStatusOrdersTitle() {
      if (!this.checkAccess("dashboard-agency-block")) {
        return this.$t("orderStatuses");
      } else if (this.checkAccess("dashboard-agency-block")) {
        return this.$t("outletDistribution");
      } else {
        return "";
      }
    },
    showAlertConfirmOrder(modal) {
      this.confirmationOrdersModalState = { ...modal, show: true };
    },
    confirmationOrdersModalAction(action, adjustmentUnlock) {
      this[action](adjustmentUnlock);
    },
    handleHeaderDots(action) {
      switch (action) {
        case "switchArchive":
          this.switchPeriod();
          break;
      }
    },
    switchPeriod() {
      this.$router.push("/addressprogramarchived/dashboard");
    },
  },
  watch: {
    currentPeriod: {
      handler(val, oldVal) {
        if (Object.keys(val).length > 0) {
          if (val?.id !== oldVal?.id) {
            this.loadData();
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    dotsHeaderOptions() {
      return [
        {
          name: "switchArchive",
          text: this.$t("switchArchive"),
          icon: "archive",
        },
      ];
    },
    isUserHasAgency() {
      return this.userinfo.agencyLinkType == "AGENCY";
    },
    showPublish: function () {
      return (
        this.checkAccess("dashboard-headerButton-publish") && this.canPublish
      );
    },
    showClose: function () {
      return (
        this.checkAccess("dashboard-headerButton-publish") && this.canClose
      );
    },
    isBreakpoint() {
      return this.breakpoint <= 1230;
    },
    isBreakpointLG() {
      return this.breakpoint <= 1100;
    },
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      access: "securityRoleAccess/access",
      currentPeriod: "marsPeriodStore/getMarsPeriod",
    }),
    homeDashboardKpi() {
      return [
        {
          title: this.$t("total"),
          plan: this.currentKpi.totalSumPlan,
          fact: this.currentKpi.totalSumFact,
          formatNumber: true,
          separatorType: ".",
        },
        {
          title: this.$t("visitSum"),
          plan: this.currentKpi.visitSumPlan,
          fact: this.currentKpi.visitSumFact,
          formatNumber: true,
          separatorType: ".",
        },
        {
          title: this.$t("oSASum"),
          plan: this.currentKpi.osaSumPlan,
          fact: this.currentKpi.osaSumFact,
          formatNumber: true,
          separatorType: ".",
        },
        {
          title: this.$t("isaOsaSum"),
          plan: this.currentKpi.deltaISAOSASumPlan,
          fact: this.currentKpi.deltaISAOSASumFact,
          formatNumber: true,
          separatorType: ".",
        },
        {
          title: this.$t("pSSSum"),
          plan: this.currentKpi.pssSumPlan,
          fact: this.currentKpi.pssSumFact,
          formatNumber: true,
          separatorType: ".",
        },
        {
          title: this.$t("tacticalTaskSum"),
          plan: this.currentKpi.tacticalTaskSumPlan,
          fact: this.currentKpi.tacticalTaskSumFact,
          formatNumber: true,
          separatorType: ".",
        },
      ];
    },
    getUuid() {
      return `homePeriodKey-${this.uniqueKey}`;
    },
    getBlockedPeriod() {
      return this.currentPeriod?.isBlocked;
    },
  },
};
</script>
<style lang="scss">
.home {
  container-type: size;
  .prospace-top-panel {
    .prospace-tag {
      height: 22px;
      font-size: 12px;
    }
  }
  &-breakpoint {
    flex-direction: column !important;
  }
  &__dashboard {
    background: var(--prospace-ui-bg-layout);
    @container (max-width: 1230px) {
      @container (min-height: 500px) {
        .prospace-geo-layout__center {
          &.prospace-scrollbar {
            padding-right: 5px;
            width: calc(100% + 9px);
          }
        }
      }
    }
    @container (min-width: 1231px) {
      @container (max-height: 810px) {
        .prospace-geo-layout__center {
          &.prospace-scrollbar {
            padding-right: 5px;
            width: calc(100% + 9px);
          }
        }
      }
    }

    &-block {
      background: var(--prospace-ui-bg);
      box-shadow: 0px 2px 10px rgba(51, 51, 51, 0.07);
      border-radius: 5px;
      max-height: 100%;
      overflow: hidden !important;
      .prospace-block {
        padding-left: 0 !important;
        padding-right: 0 !important;
        overflow: visible;
      }
      &--1-1 {
        overflow: hidden;
      }
      &--1-2 {
        flex-grow: 1;
      }
      &--2-1 {
        min-height: 22vh;
        .prospace-tag--bigheight {
          font-size: 12px;
          max-width: calc(100% - 37px);
        }
        &.home__dashboard-block--agency {
          min-height: 180px;
          @container (max-width: 1230px) {
            min-height: 205px;
          }
        }
        @container (max-width: 1230px) {
          min-height: 37vh;
          @container (max-height: 900px) {
            min-height: 49vh;
          }
        }
      }
      &--2-2 {
        min-height: 28vh;
        &.home__dashboard-block--agency {
          min-height: 180px;
          @container (max-width: 1230px) {
            min-height: 200px;
          }
        }
        @container (max-width: 1230px) {
          min-height: 29vh;
          @container (max-height: 900px) {
            min-height: 36vh;
          }
        }
      }
      &--2-3 {
        flex-grow: 1;
      }
      &--1-2,
      &--2-3,
      &--3-1 {
        overflow: hidden !important;
        position: relative;
        &:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 5px;
          z-index: 1;
          background: var(--prospace-ui-bg);
        }
        .home__dashboard-scroll,
        .home__dashboard-scroll--sidebarOpen {
          height: calc(100% - 55px) !important;
        }
      }
    }
    &-scroll {
      margin: 10px 0 0 !important;
      padding: 0 0 10px !important;
      height: calc(100% - 55px) !important;
      &--loading {
        overflow: hidden !important;
      }
      &--sidebarOpen {
        height: calc(100% - 55px) !important;
      }
    }
    &-h-statuses {
      .home-dashboard-status:first-child {
        width: calc(50% - 15px) !important;
        margin-right: 0 !important;
      }
      .home-dashboard-status:last-child {
        width: calc(50% - 15px) !important;
        margin-left: 0 !important;
      }
    }
    &-column {
      height: 100% !important;
      width: calc(100% / 3 - 10px) !important;
      &:last-child {
        width: calc(100% / 3) !important;
      }
    }
  }
  &__wrapper {
    align-items: flex-start !important;
    @container (max-width: 1230px) {
      &--agency {
        min-height: 610px !important;
      }
    }
    @container (min-width: 1231px) {
      &--agency {
        @container (min-height: 700px) {
          min-height: 80vh;
        }
      }
    }
  }
  &__green-button {
    background-color: var(--prospace-tag-teal);
  }
  &__green-button:hover {
    background-color: #18ad90;
  }
  .legend {
    width: 12px;
    height: 12px;
    border-radius: 3px;
    &--plan {
      background: var(--prospace-chart-plan);
    }
    &--fact {
      background: var(--prospace-chart-fact);
    }
  }
  &__btn-reload {
    margin-right: 10px;
  }
  .pointer-events-none {
    pointer-events: none;
  }
}
.confirmation-orders-modal {
  .prospace-modal-wrapper {
    overflow: hidden;
  }
  .prospace-checkbox {
    padding: 8px 15px;
  }
}
</style>
